import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AutoUnsubscribe implements OnDestroy {
  private readonly destroyed$ = new Subject<void>();

  protected autoUnsubscribe<T>(o$: Observable<T>): Observable<T> {
    return o$.pipe(takeUntil(this.destroyed$));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
